module.exports = __webpack_public_path__ + "img/menu.bf889bda.svg";